module.exports = __webpack_public_path__ + "img/hi.f76499d0.png";